import React, { ReactNode } from 'react';
import moment from 'moment-timezone';
import './reservableSlotCard.module.scss';
import { ReservationIndexView } from '../../../../types/reservations';
import { SimpleDate } from '../../../../../admin/components/date/TimeRange';

type LabelProps = { r: ReservationIndexView };

const ReservationLabel = ({ r }: LabelProps) => (
  <div styleName="reservation-label">
    <SimpleDate date={r.reservable.starts_at} />
    &nbsp;{moment(r.reservable.starts_at).format('HH:mm')}~
  </div>
);

type ReservableCardProps = {
  title: ReactNode;
  reservationList: ReservationIndexView[];
  text: ReactNode;
};
export const MultiCreatorReservableSlotCard = ({ title, reservationList, text }: ReservableCardProps) => {
  return (
    <div styleName="card">
      <div styleName="left">
        <div styleName="title">{title}</div>
        <div styleName="remaining">
          {reservationList.length > 0 && (
            <div styleName="reservations">
              {reservationList.map((r) => (
                <ReservationLabel key={r.id} r={r} />
              ))}
            </div>
          )}
        </div>
      </div>
      <div styleName="text">{text}</div>
    </div>
  );
};
